import {
  IAction,
  type IStep,
  useChatMessages,
  useConfig
} from '@chainlit/react-client';

import CopyButton from '@/components/CopyButton';

import MessageActions from './Actions';
import { DebugButton } from './DebugButton';
import { FeedbackButtons } from './FeedbackButtons';

interface Props {
  message: IStep;
  actions: IAction[];
  run?: IStep;
  contentRef?: React.RefObject<HTMLDivElement>;
}

const MessageButtons = ({ message, actions, run, contentRef }: Props) => {
  const { config } = useConfig();
  const { firstInteraction } = useChatMessages();

  const isUser = message.type === 'user_message';
  const isAsk = message.waitForAnswer;
  const hasContent = !!message.output;
  const showCopyButton = hasContent && !isUser && !isAsk; // RAGBOT: no need to check for 'run'

  const messageActions = actions.filter((a) => a.forId === message.id);

  const showDebugButton =
    !!config?.debugUrl && !!message.threadId && !!firstInteraction; // RAGBOT: no need to check for 'run'

  const show = showCopyButton || showDebugButton || messageActions?.length;

  if (!show || message.streaming) {
    return null;
  }

  // RAGBOT: actions are rendered below the button row so they can be laid out
  // in a column with wrapping labels (see Actions/index.tsx).
  return (
    <>
      <div className="-ml-1.5 flex items-center flex-wrap">
        {showCopyButton ? (
          <CopyButton content={message.output} contentRef={contentRef} />
        ) : null}
        {run ? <FeedbackButtons message={run} /> : null}
        {showDebugButton ? (
          <DebugButton debugUrl={config.debugUrl!} step={message} />
        ) : null}
      </div>
      {messageActions.length ? (
        <MessageActions actions={messageActions} />
      ) : null}
    </>
  );
};

export { MessageButtons };
